import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';

import {
	defaultSYS5010_R01Filter,
	SYS5010_R01Dto,
	SYS5010_R01Filter,
} from './Dto_SYS5010_R01';

export type { SYS5010_R01Filter };
export { defaultSYS5010_R01Filter };

export interface Store_SYS5010_R01 {
	SYS5010_R01Filter: SYS5010_R01Filter;
	SYS5010_R01PastFilter: SYS5010_R01Filter;
	setSYS5010_R01Filter: (filter: Partial<SYS5010_R01Filter>) => void;
	setSYS5010_R01PastFilter: (filter: SYS5010_R01Filter) => void;

	SYS5010_R01List: SYS5010_R01Dto[];
	setSYS5010_R01List: (dataList: SYS5010_R01Dto[]) => void;

	selectedSYS5010_R01: SYS5010_R01Dto | undefined;
	setSelectedSYS5010_R01: (row: SYS5010_R01Dto | undefined) => void;
	initSelectedSYS5010_R01: () => void;

	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;
	setAllCount: (count: number) => void;

	initData: () => void;
}

export const useSYS5010_R01Store = create<Store_SYS5010_R01>((set) => ({
	SYS5010_R01Filter: defaultSYS5010_R01Filter,
	SYS5010_R01PastFilter: defaultSYS5010_R01Filter,
	setSYS5010_R01Filter: (update) =>
		set((state) => ({
			SYS5010_R01Filter: { ...state.SYS5010_R01Filter, ...update },
		})),
	setSYS5010_R01PastFilter: (filter) => set({ SYS5010_R01PastFilter: filter }),

	SYS5010_R01List: [],
	setSYS5010_R01List: (dataList) =>
		set({
			SYS5010_R01List: dataList.map((item, index) => ({
				...item,
				valueIndex: index + 1,
			})),
		}),

	selectedSYS5010_R01: undefined,
	setSelectedSYS5010_R01: (row) => set({ selectedSYS5010_R01: row }),
	initSelectedSYS5010_R01: () => set({ selectedSYS5010_R01: undefined }),

	columnState: null,
	setColumnState: (state) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top) => set({ scrollTop: top }),

	allCount: 0,
	setAllCount: (count) => set({ allCount: count }),

	initData: () =>
		set({
			SYS5010_R01Filter: defaultSYS5010_R01Filter,
			SYS5010_R01PastFilter: defaultSYS5010_R01Filter,
			SYS5010_R01List: [],
			selectedSYS5010_R01: undefined,
			columnState: null,
			scrollTop: null,
			allCount: 0,
		}),
}));
